var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010\\u98DE\\u6868\\u3011\\u6A21\\u578B\\u9009\\u578B\\u53C2\\u6570",
    transform: "translate(-258.000000, -682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(242.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "currentColor",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666667,9.7988084 L13.6666667,14.4654751 L13.0833333,14.4654751 L2.58333333,14.4654751 L2,14.4654751 L2,9.7988084 L2.58333333,9.7988084 L3.16666667,9.7988084 L3.16666667,13.2988084 L12.5,13.2988084 L12.5,9.7988084 L13.0833333,9.7988084 L13.6666667,9.7988084 Z M7.42080729,2.36805319 L7.83333333,2 L8.24585938,2.36805319 L10.5791927,4.70138653 L11.0054239,5.12569676 L10.5791927,5.52643858 L10.1518483,5.94254787 L9.75414063,5.52643861 L8.41666667,4.18896465 L8.41666667,12.1321417 L7.83333333,12.1321417 L7.25,12.1321417 L7.25,4.18896465 L5.91252604,5.52643861 L5.5206913,5.94254787 L5.08747405,5.52643852 L4.6636391,5.12569676 L5.08747396,4.70138653 L7.42080729,2.36805319 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadBtn);
export default __webpack_public_path__ + "static/media/icon_upload-btn.9e14f639.svg";
export { ForwardRef as ReactComponent };